module.exports = __webpack_public_path__ + "img/7.de4c43d9.png";